export const IMAGE = (id) => ({
    idImage: id,
    type: 'image',
    isSquare: false,
    left: 10,
    top: 290,
    scaleY: 0,
    scaleX: 0,
    height: 1920,
    width: 1080,
    angle: 0,
})
